import React from 'react'
import { useEffect, useMemo } from 'react'

import { useAllowExistingListItems } from './useAllowExistingListItems'

import { LIST_ITEM_OPTION, OPTION_EXISTING_LIST_ITEM } from './fields'

export const useManageExistingListItemFormStep = ({
  values,
  newListItemSteps,
  onListItemOptionChange,
  ListItemSelectionStep,
  listItems
}) => {
  // In some forms, we allow to select existing list item, and not create new one,
  // so we need to show only list item selection step
  // This hook helps to manage which steps to show, only 1 existing list item step or new list item steps
  const { showListItemSelectionStep } = useAllowExistingListItems(listItems)

  const listItemOption = values[LIST_ITEM_OPTION]
  const showOnlyListItemSelectionStep = values[LIST_ITEM_OPTION] === OPTION_EXISTING_LIST_ITEM

  const steps = useMemo(() => {
    return [
      ...(showListItemSelectionStep
        ? [
            {
              component: React.cloneElement(ListItemSelectionStep, {
                showContinueButton: !showOnlyListItemSelectionStep
              }),
              show: true
            }
          ]
        : []),
      ...(!showOnlyListItemSelectionStep ? newListItemSteps : [])
    ]
  }, [showListItemSelectionStep, showOnlyListItemSelectionStep, ListItemSelectionStep, newListItemSteps])

  useEffect(() => {
    if (onListItemOptionChange && listItemOption) {
      onListItemOptionChange(listItemOption)
    }
  }, [listItemOption, onListItemOptionChange])

  return steps
}
